import * as React from "react"

function SvgClose(props) {
  return (
    <svg
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.707 0L0 .707 5.303 6.01 0 11.314l.707.707L6.01 6.718l5.304 5.303.707-.707L6.718 6.01 12.02.707 11.314 0 6.01 5.303.707 0z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgClose
